module.exports = __webpack_public_path__ + "static/media/16.60f214c4.jpg";